import * as React from "react";
import { useTranslation } from "react-i18next";

import { subpageContext } from "components/layout/ApplicationLayout";
import ManageLicenseKeyView from "components/licenses/assign-bms-keys/ManageLicenseKeyView";
import { LicenseData } from "domain/licenses";
import { Action, Category, usageStatisticsService } from "services/statistics/UsageStatisticsService";
import buttonsStyle from "styles/buttons.scss";

import testIds from "testIds.json";

function AssignKeysView(props: {
    updateTable: () => void;
    availableLicenses: LicenseData[];
    fromBms: boolean;
}): JSX.Element {
    const { t } = useTranslation();
    const [assignVisible, setAssignVisible] = React.useState(false);
    const context = React.useContext(subpageContext);
    function onSuccess() {
        usageStatisticsService.sendEvent({
            category: Category.LICENSE,
            action: props.fromBms ? Action.ASSIGN_LICENSE_KEY : Action.ASSIGN_OEM_LICENSE_KEY,
        });
        context?.setSubpage({
            content: undefined,
        });
        setAssignVisible(true);
        props.updateTable();
    }

    function onFetchLicensesFailure() {
        setAssignVisible(false);
        context?.setSubpage({
            content: undefined,
        });
    }

    React.useEffect(() => {
        if (assignVisible && context?.setSubpage) {
            context?.setSubpage({
                content: (
                    <>
                        <ManageLicenseKeyView
                            isEdit={false}
                            onSuccess={onSuccess}
                            onFetchLicensesFailure={onFetchLicensesFailure}
                            fromBms={props.fromBms}
                            availableLicenses={props.availableLicenses}
                        />
                    </>
                ),
                isModal: false,
            });
        }
    }, [assignVisible]);

    const assignKeysText = t("Licenses.bms.assignKeys");

    return (
        <>
            <div>
                <button
                    className={buttonsStyle.primaryButtonWithoutIcon}
                    disabled={assignVisible}
                    onClick={() => setAssignVisible(true)}
                    data-testid={
                        props.fromBms
                            ? testIds.workArea.license.bms.assignKeysButton
                            : testIds.workArea.license.serialNumber.assignKeysButton
                    }
                >
                    {assignKeysText}
                </button>
            </div>
        </>
    );
}

export default AssignKeysView;
